module.exports = __webpack_public_path__ + "images/landing/video-previews/truffaldino_2x.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/video-previews/truffaldino_2x.jpg
// module id = EY2t
// module chunks = 1